<div class="dry-run" *ngIf="isDebugAvailable()">
  <div class="d-flex align-items-center">
    <button class="btn btn-primary btn-primary-extra-light mr-2"
      (click)="openDebug(true, true); $event.stopPropagation()" [disabled]="isLoading"
      tooltip="{{ 'Check errors' | translate }}">
      {{ 'Check errors' | translate }}
      <i *ngIf="isLoading" class="ml-2 fad fa-spin fa-spinner-third"></i>
      <span *ngIf="!isLoading && results?.length > 0 && debugMode" class="ml-2 badge badge-danger">
        {{ results.length }}
      </span>
    </button>
  </div>

  <!-- Results Drawer -->
  <drawer [title]="'Debug Results' | translate" [isClosed]="drawerOpen ? false : true" [hideCancel]="true"
    [hideSave]="true" [contextVariant]="'danger'"
    [contextLabel]="results && results.length > 0 ? (results.length + ' ' + ('Issues' | translate)) : ('No Issues' | translate)"
    [noContentPadding]="true" (closeEvent)="closeDrawer()" [showToggle]="true" [toggleLabel]="'Debug Mode'"
    [toggleValue]="debugMode" (toggleChange)="onDebugModeChange($event)">
    <div class="drawer-content drawer-direct-content">
      <div class="table-items p-3" *ngIf="results && results.length > 0">
        <!-- Grouped Results by Type and Item -->
        <div *ngFor="let groupKey of sortedGroupKeys" class="row fields-group">
          <div class="col d-flex flex-column">
            <!-- Main Group Header (Type) -->
            <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1"
              (click)="groupOpenState.set(groupKey, !groupOpenState.get(groupKey))"
              [ngClass]="{'expanded': groupOpenState.get(groupKey) ?? true}">
              <div class="col justify-content-between d-flex">
                <label class="input-label mb-0">
                  {{ groupKey | translate }}
                  <span class="badge badge-danger ml-2">{{ groupErrorCounts.get(groupKey) }}</span>
                </label>
                <i class="fas ml-auto mt-1"
                  [ngClass]="{'fa-chevron-down': !groupOpenState.get(groupKey), 'fa-chevron-up': groupOpenState.get(groupKey)}"
                  aria-hidden="true"></i>
              </div>
            </div>

            <!-- Items grouped by sub-group (no accordion) -->
            <ng-container *ngIf="groupOpenState.get(groupKey) ?? true">
              <div *ngFor="let subGroupEntry of groupedResults.get(groupKeyMapping.get(groupKey)) | keyvalue"
                class="mt-2">
                <!-- Sub-group label -->
                <div class="text-body small font-weight-bold mb-1">{{ subGroupEntry.key }}</div>

                <!-- Errors in this sub-group -->
                <div *ngFor="let p of subGroupEntry.value" class="row mb-1">
                  <div class="col">
                    <div class="row d-flex align-items-center">
                      <a [href]="prepareLinkToComponent(p)"
                        class="col d-flex align-items-center justify-content-start flex-wrap gap-2" target="_blank">
                        <div class="badge badge-danger">
                          {{ p.objectType | translate | replaceUnderscore }}
                        </div>
                        <span *ngIf="p.conflictingValue || subGroupEntry.key !== p.componentKey"
                          class="badge badge-light my-0">{{ formatTargetItem(p) }}</span>
                        <i class="far fa-ellipsis-v btn-xs btn-icon simple-icon cursor-pointer ml-auto"
                          [popover]="mistakeKeys" container="body" containerClass="confirmation-popover"
                          placement="right" triggers="mouseenter mouseleave" #pop="bs-popover"></i>
                        <ng-template #mistakeKeys>
                          <table class="m-0 table-small">
                            <thead>
                              <tr>
                                <th>{{ 'Conflicting value' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <small>{{ p.objectId || p.conflictingValue }}</small>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </ng-template>
                      </a>
                    </div>
                    <!--
                    <div class="row mt-2 mb-1">
                      <div class="col text-muted small" [innerHTML]="(p.message | translate) | safeHtml"></div>
                    </div>
                    -->
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="results && results.length === 0" class="alert alert-info my-3">
        {{ 'No issues found' | translate }}
      </div>
    </div>
  </drawer>
</div>